import { gql, NetworkStatus, useQuery } from '@apollo/client'
import { addMinutes } from 'date-fns'
import { useState } from 'react'
import useSound from 'use-sound'
import videoSupervisionCustomerWaitingSfx from '../../../sounds/videoSupervisionCustomerWaiting.mp3'
import { VideoQueueLengthQuery } from './__generated__/VideoQueueLengthQuery'

const videoQueueLengthQuery = gql`
  query VideoQueueLengthQuery {
    videoQueue {
      totalCount
    }
  }
`

const useVideoQueueLength = () => {
  const [lastPlayed, setLastPlayed] = useState<Date>()
  const [playVideoSupervisionCustomerWaiting] = useSound(videoSupervisionCustomerWaitingSfx)

  const { data, networkStatus } = useQuery<VideoQueueLengthQuery>(videoQueueLengthQuery, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    notifyOnNetworkStatusChange: true,
    pollInterval: 10000,
    onCompleted: (data) => {
      const { totalCount } = data.videoQueue

      if (totalCount > 0 && (!lastPlayed || lastPlayed < addMinutes(new Date(), -5))) {
        playVideoSupervisionCustomerWaiting()
        if (totalCount > 2) {
          window.setTimeout(playVideoSupervisionCustomerWaiting, 1000)
        }
        setLastPlayed(new Date())
      }
    },
  })

  return {
    queueLength: data?.videoQueue?.totalCount,
    loading: networkStatus === NetworkStatus.loading,
  }
}

export default useVideoQueueLength
